<template>
  <!-- D : 판매종료시 is-card-soldout 추가 -->
  <div class="c-product-card type-horizontal is-card-soldout">
    <div class="c-checkbox type-small">
      <input
        type="checkbox"
        :id="'mo-out-basket-chk-' + index"
        name="mo-out-basket-chk1"
        :checked="checkedValue"
        @change="toggleItem()"
      />
      <label :for="'mo-out-basket-chk-' + index">
        <span class="sr-only">상품선택</span>
      </label>
    </div>
    <div class="product-thumb">
      <button type="button" class="thumb-button">
        <div class="product-img">
          <img
            class="no-image"
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
          />
        </div>
        <div class="thumb-bottom">
          <p class="text">제품상세</p>
          <i class="c-icon icon-plus"></i>
        </div>
      </button>
    </div>
    <div class="product-info">
      <div v-show="!productBadgeEmptyYn" class="c-product-badge">
        <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>

        <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>

        <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="c-product-category">
        <span class="path">{{ item.prodh1t }}</span>
        <span class="path">{{ item.prodh2t }}</span>
        <span class="path">{{ item.prodh3t }}</span>
      </div>
      <div class="product-code">{{ item.matnr }}</div>
      <strong class="product-name">{{ item.zzmaktx }}</strong>

      <div class="info-bottom">
        <p class="price">
          <strong class="system">{{
            Number(item.kbetr * item.goodsQty).toLocaleString()
          }}</strong
          >원
        </p>
      </div>
    </div>
    <!-- D : 판매종료 dim -->
    <div class="card-dim">
      <p class="text">담당영업사원 통한 주문품 주문건</p>
      <i class="c-icon icon-check-circle"></i>
    </div>
    <!-- // D : 판매종료 dim -->
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits, computed, watch } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
  checked: {
    type: Boolean,
    require: true,
  },
});

const emit = defineEmits(["checked", "detail", "ordertemp"]);

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item); // 제품
const imageErrorYn = ref(false);
const checkedValue = computed({
  get: () => props.checked,
  set: (value) => emit("checked", value),
});

onMounted(() => {});

watch(
  () => props.item,
  (newValue) => {
    item.value = newValue;
  }
);

// 체크박스
function toggleItem() {
  checkedValue.value = !checkedValue.value;
}

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});
</script>
